module.exports = __webpack_public_path__ + "static/logo-07@2x.97cd2af0.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/company_images/logo-07@2x.png
// module id = 833
// module chunks = 168707334958949